export const MARGIN_TOP = 16 * 2;
export const MARGIN_RIGHT = 8;
export const MARGIN_BOTTOM = 16;
export const MARGIN_LEFT = 8;

export const TOTAL_HORIZONTAL_MARGIN = MARGIN_LEFT + MARGIN_RIGHT;
export const TOTAL_VERTICAL_MARGIN = MARGIN_TOP + MARGIN_BOTTOM;
